import React, { useEffect, useRef, useState } from 'react'
import SImage from '../Image'
import { AvatarFemale, LogoAdda } from '../../assets'
import '../../assets/plugins/plugins.bundle.css'
import { API_BASE_URL, FE_BASE_URL } from '../../config';
import './index.css';
import SButton from '../Button';

function SNavbar({user}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loadingLogout, setLoadingLogout] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, []);

  const handleLogout = async () => {
    setLoadingLogout(true);
    try {
        const token = localStorage.getItem('access_token');
        const res = await fetch(
            `${API_BASE_URL}/auth/logout`, 
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }
        );
        
        if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            alert(errorData.message || 'Gagal, Koneksi!');
            return;
        }

        const response = await res.json();
        if(response){
            window.location.href = `${FE_BASE_URL}`
        }
    } catch (err) {
      alert('Connection Failed!')
    } finally{
        localStorage.removeItem('access_token');
        setLoadingLogout(false);
    }
  }

  return (
    <>
    <div className='app-header'>
        <div className='app-container container-xxl d-flex align-items-stretch justify-content-between'>
            <div className='d-flex align-items-center d-lg-none ms-n2 me-2'>
                <div className='btn btn-icon btn-active-color-primary w-35px h-35px'>
                    <i className='ki-outline ki-abstract-14 fs-2'></i>
                </div>
            </div>
            <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-1 me-lg-13'>
                <a href='project.html'>
                    <SImage alt={'logo'} source={LogoAdda} className={'h-20px h-lg-30px theme-light-show'}/>
                </a>
            </div>
            <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                <div className='d-flex align-items-stretch' id='kt_app_header_menu_wrapper'>
                    <div className='app-header-menu app-header-mobile-drawer align-items-stretch'>
                        <div className='menu menu-rounded menu-column menu-lg-row menu-active-bg menu-title-gray-600 menu-state-gray-900 menu-arrow-gray-500 fw-semibold fw-semibold fs-6 align-items-stretch my-5 my-lg-0 px-2 px-lg-0' >
                            <div className='menu-item here show menu-here-bg menu-lg-down-accordion me-0 me-lg-2'>
                                <span className='menu-link'>
                                    <span className='menu-icon'>
                                        <i className='ki-outline ki-graph-3'></i>
                                    </span>
                                    <span className='menu-title' style={{color: '#000'}}>Home</span>
									<span className='menu-arrow d-lg-none'></span>
                                </span>
                            </div>

                            <div className='menu-item menu-lg-down-accordion me-0 me-lg-2'>
                                <span className='menu-link'>
                                    <span className='menu-icon'>
                                        <i className='ki-outline ki-category'></i>
                                    </span>
                                    <span className='menu-title' style={{color: '#000'}}>Pages</span>
									<span className='menu-arrow d-lg-none'></span>
                                </span>
                            </div>

                            <div className='menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2'>
                                <span className='menu-link'>
                                    <span className='menu-icon'>
                                        <i className='ki-outline ki-watch'></i>
                                    </span>
                                    <span className='menu-title' style={{color: '#000'}}>Apps</span>
									<span className='menu-arrow d-lg-none'></span>
                                </span>
                            </div>

                            <div className='menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2'>
                                <span className='menu-link'>
                                    <span className='menu-icon'>
                                        <i className='ki-outline ki-setting-2'></i>
                                    </span>
                                    <span className='menu-title' style={{color: '#000'}}>Help</span>
									<span className='menu-arrow d-lg-none'></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='app-navbar flex-shrink-0'  ref={dropdownRef}>
                <div className='app-navbar-item' id='kt_header_user_menu_toggle' style={{ position: 'relative' }} >
                    <div className='d-flex align-items-center border border-dashed border-gray-300 rounded p-2'
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className='cursor-pointer symbol me-3 symbol-35px symbol-lg-45px'>
                            <SImage alt={'user'} source={AvatarFemale} />
                        </div>
                        <div className='me-4'>
                            <span className='text-gray-900 text-hover-primary fs-6 fw-bold'>{user.user.full_name}</span>
                            <span className='text-gray-500 text-hover-primary fs-7 fw-bold d-block'>{user.user.name_permission}</span>
                        </div>
                        <i className="ki-outline ki-down fs-2 text-gray-500 pt-1"></i>
                    </div>
                    {dropdownOpen && (
                        <div className="navbar-dropdown-logout">
                            <SButton
                                className={'ki-outline ki-logout me-2'}
                                variant={'transparent'}
                                size={'sm'}
                                action={() => handleLogout()}
                                disabled={loadingLogout}
                            >
                                {loadingLogout ? (
                                    <span>
                                        <i className="spinner-border spinner-border-sm me-2"></i>
                                        Logging out...
                                    </span>
                                    ) : (
                                    'Logout'
                                )}
                            </SButton>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default SNavbar